
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Workorder, CostsApi, ValidationProblemDetails } from 'performo-api';

import { mapGetters } from 'vuex';
import { User } from 'oidc-client';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    api: 'costsApi'
  })
})
export default class AddLaborComponent extends Vue {
  private api!: CostsApi;
  private currentUser!: User;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  get orderReactive() {
    return this.order;
  }

  get dateInISO() {
    return this.getDateInYYYYMMDD(this.laborDate);
  }

  private popoverOpen = false;
  private worker = '';
  private hours = 0;
  private laborDate = new Date();

  data() {
    return {
      worker: '',
      hours: 0,
      laborDate: new Date()
    };
  }

  async mounted() {
    // set default
    this.worker = this.currentUser.profile.WorkerVendor || '';
  }

  async addLabor() {
    const addedLabor = await this.api
      .createCostLabor({
        costLaborCreateCommand: {
          workorderId: this.order.workorderId,
          tcardRecordType: 'Work Order',
          laborName: this.worker,
          laborHours: this.hours,
          laborDate: new Date(
            this.laborDate.getTime() -
              this.laborDate.getTimezoneOffset() * 60000
          ),
          propertyId: this.order.propertyId
        }
      })
      .then(() => {
        // success, emit event
        this.$emit('labor-added', addedLabor);
        // close and reset form
        this.cancelLabor();
      })
      .catch(this.editorError)
      .finally(() => {
        // empty
      });
  }

  cancelLabor() {
    this.worker = this.currentUser.profile.WorkerVendor || '';
    this.hours = 0;
    this.laborDate = new Date();

    this.problems = [];
    this.popoverOpen = false;
  }

  private updateLaborDate(datePicked: string) {
    // need to manually parse string into Date
    // to avoid UTC offset issues when casting
    let stringToDate = new Date(
      parseInt(datePicked.substring(0, 4)),
      parseInt(datePicked.substring(5, 7)) - 1,
      parseInt(datePicked.substring(8, 10))
    );

    this.laborDate = stringToDate;
  }

  // date picker accepts string formatted in YYYY-MM-DD
  private getDateInYYYYMMDD(currentDate: Date) {
    // year
    let yyyy = '' + currentDate.getFullYear();

    // month
    let mm = '0' + (currentDate.getMonth() + 1); // prepend 0 // +1 is because Jan is 0
    mm = mm.substr(mm.length - 2); // take last 2 chars

    // day
    let dd = '0' + currentDate.getDate(); // prepend 0
    dd = dd.substr(dd.length - 2); // take last 2 chars

    return yyyy + '-' + mm + '-' + dd;
  }

  private problems: ValidationProblemDetails = [];

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }
    this.problems = vpd;
  }

  get clientSideValidation() {
    return this.worker && this.hours && this.hours > 0 && this.laborDate;
  }
}
